import ApiLibrary from "./ApiLibrary";

class Feedback extends ApiLibrary.Base {
  static className = "Feedback";

  static define() {}
}

export default ApiLibrary.createResource(Feedback);
